import { render, staticRenderFns } from "./VoipConfigForm.vue?vue&type=template&id=d00bde92&scoped=true&"
import script from "./VoipConfigForm.vue?vue&type=script&lang=js&"
export * from "./VoipConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./VoipConfigForm.vue?vue&type=style&index=0&id=d00bde92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00bde92",
  null
  
)

export default component.exports